<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">数据中心</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">跟进统计</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-statistics">
            <a-tabs default-active-key="1" @change="callback">
                <a-tab-pane key="1" tab="按所跟进对象统计"></a-tab-pane>
                <a-tab-pane key="2" tab="按跟进类型统计"></a-tab-pane>
            </a-tabs>

            <div class="top-search">
                <a-row type="flex">
                    <a-col><label for="">创建时间：</label></a-col>
                    <a-col>
                        <div class="select-date-custom">
                            <a-input class="search-date" v-model="time" @click="showdate">
                                <a-tooltip slot="suffix" title="Extra information">
                                    <div class="date-icon"></div>
                                </a-tooltip>
                            </a-input>
                            <span class="select-date-modal" v-if="dateshow">
                                <div class="date-modal">
                                    <div class="time-modal">
                                        <div class="time-system">
                                            <div class="select-item" @click="selectdate2(i,item)" :class="{clickdate:i==currentdate}" v-for="(item,i) in datelist2" :key="i">{{item}}</div>
                                        </div>
                                        <div class="time-custom">
                                            <span class="time-system-text">自定义</span>
                                            <div class="time-select-index-hide">
                                                <a-date-picker format="YYYY-MM-DD" @change="dateChange2"/>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </a-col>
                </a-row>

                <!-- <a-row  type="flex">
                    <a-col><label for="">部门：</label></a-col>
                    <a-col>
                        <a-select default-value="lucy" style="width: 120px" @change="handleChange">
                            <a-select-option value="jack">
                                Jack
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row> -->

                <a-row  type="flex">
                    <a-col><label for="">员工：</label></a-col>
                    <a-col>
                        <a-select maxTagCount="0"  mode="multiple" placeholder="选择员工" v-model="belong" style="width: 120px" @change="handleChangeyg">
                            <!-- <a-icon slot="suffixIcon" type="user-add" /> -->
                            <a-select-option v-for="item in userlist" :value="item.id" :key="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <!-- <a-row  type="flex">
                    <a-col><label for="">跟进类型：</label></a-col>
                    <a-col>
                        <a-select default-value="1" style="width: 120px" @change="handleChange">
                            <a-select-option value="1">
                                呼入
                            </a-select-option>
                            <a-select-option value="2">
                                呼出
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row> -->
            </div>

            <div class="tj-charts">

                <div class="chart-content">
                    <div id="weightChart" style="width: 100%;height:394px;"></div>
                </div>
            </div>

            
            <div class="table-content">
                <div v-if="table1" class="table-top-info">
                    <a-button icon="upload">导出</a-button>
                    <div>更进线索次数：{{total.totaldata}}</div>
                    <div>跟进客户次数：{{total.totalkehu}}</div>
                    <div>跟进商机次数：{{total.totalbussness}}</div>
                    <div>跟进总次数：{{total.total}}</div>
                </div>

                <div v-if="table2" class="table-top-info">
                    <a-button icon="upload">导出</a-button>
                    <div>写跟进次数：{{total2.follownum}}</div>
                    <div>打电话次数：{{total2.callnum}}</div>
                    <div>跟进总次数：{{total2.notenum}}</div>
                </div>

                <a-table v-if="table1" :columns="columns" :data-source="data">
                    <a slot="name" slot-scope="text">{{ text }}</a>
                </a-table>

                <a-table v-if="table2" :columns="columns2" :data-source="data2">
                    <a slot="name" slot-scope="text">{{ text }}</a>
                </a-table>
            </div>
        </div>
    </div>
</template>

<script>
const columns = [
  {
    title: '员工姓名',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '线索数',
    dataIndex: 'datanum',
    key: 'datanum',
  },
  {
    title: '客户数',
    dataIndex: 'kehunum',
    key: 'kehunum',
    ellipsis: true,
  },
  {
    title: '联系人数',
    dataIndex: 'contractnum',
    key: 'contractnum',
    ellipsis: true,
  },
  {
    title: '商机数',
    dataIndex: 'bussnessnum',
    key: 'bussnessnum',
    ellipsis: true,
  }
];

const columns2 = [
  {
    title: '员工姓名',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '写跟进次数',
    dataIndex: 'follownum',
    key: 'follownum',
  },
  {
    title: '打电话次数',
    dataIndex: 'callnum',
    key: 'callnum',
    ellipsis: true,
  },
  {
    title: '跟进总次数',
    dataIndex: 'notenum',
    key: 'notenum',
    ellipsis: true,
  }
];


export default {
    data(){
        return{
            data:"",
            data2:"",
            columns2,
            columns,
            total:"",
            total2:"",
            echarts1:"",
            echarts2:"",
            datelist2:['今天','昨天','本周','上周','本月','上月'],
            currentdate:"",
            dateshow:false,
            time:"今天",
            table1:true,
            table2:false,

            userlist:"",
            belong:[],
        }
    },
    mounted(){
        this.byobjecttj()

         //  员工列表
        this.$axios.get('/api/userlist',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }  
         }).then((res)=>{
            if(res.data.code==200){
            this.userlist=res.data.data.lists
            }else{
            this.$message.error(res.data.msg);
            }
         })
    },
    methods:{
         // 员工筛选
        handleChangeyg(value){
            this.belong=value
            this.gjtj()
        },
        // 日期选择
        handleChange(){

        },
        showdate(){
            this.dateshow=!this.dateshow
        },
        selectdate2(a,b){
            this.currentdate=a
            this.time=b
            this.dateshow=false
            this.bystafftj()
            this.bydatetj()
        },
        dateChange2(data,dateString){
            console.log(dateString)
            this.time=dateString
            this.dateshow=false
            this.bystafftj()
            this.bydatetj()
        },

        // 切换tab
        callback(key){
            if(key==1){
                this.byobjecttj()
                this.table1=true
                this.table2=false
            }else if(key==2){
                this.table1=false
                this.table2=true
                this.bytypetj()
            }
        },

        byobjecttj(){
            // 跟进对象统计
            this.$axios.get('/api/followstatistic',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.time,
                    belong:this.belong
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.data=res.data.data.list
                    this.total=res.data.data.statistic
                    this.echarts1=res.data.data.echarts
                    this.drawLine()
                }else{
                    this.$message.error(res.data.msg);
                }
            })

        },

        bytypetj(){
            // 跟进类型统计
            this.$axios.get('/api/followstatisticbytype',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.time,
                    belong:this.belong
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.data2=res.data.data.list
                    this.total2=res.data.data.statistic
                    this.echarts1=res.data.data.echarts
                    this.drawLine()
                }else{
                    this.$message.error(res.data.msg);
                }
            })

        },


        drawLine(){
            var weightChart = this.$echarts.init(document.getElementById("weightChart"))
            weightChart.setOption({
                legend: {
                     y: 'bottom',    //延Y轴居中
                },
                tooltip: {},
                // dataset: {
                //     dimensions: ['product', '线索数', '客户数', '联系人数', '商机数'],
                //     source: [
                //         {product: 'Matcha Latte', '线索数': 43.3, '客户数': 85.8, '联系人数': 93.7},
                    
                //     ]
                // },
                grid: {  
                    left: '1%',  
                    right: '4%', 
                    top:'10%', 
                    bottom: '10%',  
                    containLabel: true  
                },
                xAxis: {
                    type: 'category',
                    data:this.echarts1.xaixs
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.echarts1.yaixs,
                    type: 'bar',
                    barWidth: 40,
                    itemStyle: {
                    normal: {
            　　　　　　　　//这里是重点
                            color: function(params) {
                                //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                                var colorList = ['#5e83f9','#50e5cc', '#25c9fd', '#bd6ff2'];
                                return colorList[params.dataIndex]
                            }
                        }
                    }
                }
                   
            //         {type: 'bar',barWidth: 40,barGap: '240%', itemStyle: {
            //             normal: {
            // 　　　　　　　　//这里是重点
            //                 color: "#5e83f9"
            //             }
            //         }},
            //         {type: 'bar',barWidth: 40, itemStyle: {
            //             normal: {
            // 　　　　　　　　//这里是重点
            //                 color: "#50e5cc"
            //             }
            //         } },
            //         {type: 'bar',barWidth: 40, itemStyle: {
            //             normal: {
            // 　　　　　　　　//这里是重点
            //                 color: "#25c9fd"
            //             }
            //         }},
            //         {type: 'bar',barWidth: 40, itemStyle: {
            //             normal: {
            // 　　　　　　　　//这里是重点
            //                 color: "#bd6ff2"
            //             }
            //         }},
                    
                    
                ]
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/data/follow.vue